import Crud from '../views/TipoUnidade/Crud'
import Entity from '../views/TipoUnidade/Add'

let routes = {
    path: '/tipo_unidades',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/tipo_unidades/add',
            name: 'NewTipoUnidade',
            component: Entity
        },
        {
            path: '/tipo_unidades/edit/:id?',
            name: 'EditTipoUnidade',
            component: Entity
        },
        {
            path: '/tipo_unidades',
            name: 'list-tipo_unidades',
            component: Crud,
            meta: {
                pageTitle: '',
                breadcrumb: [
                    {
                        text: 'Tipos de Unidade',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
